module.exports = __webpack_public_path__ + "img/liu_ming.f93cf0b4.jpg";